<div>
    <app-tool-bar [title]="'Course Configuration'" [iconName]="'pi-book'" [isAdd]="true"
        (handleAdd)="handleAddCourse()"></app-tool-bar>
</div>

<div class="p-4 overflow-auto h-[85vh]">
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
        [loading]="loading">

        <!-- Header -->
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5rem">S.No</th>
                <th *ngFor="let col of columns">
                    {{ col.header }}
                </th>
            </tr>
        </ng-template>

        <!-- Body -->
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
                <td>
                    <div style="margin-left: 5px;">
                        {{ rowIndex + 1 }}
                    </div>
                </td>
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">
                        <ng-container *ngSwitchCase="'actions'">
                            <div *ngIf="!loading" (click)="setCourseData(rowData)">
                                <p-menu [tabindex]="undefined" #menu [model]="courseActionItems" [popup]="true"
                                    appendTo="body">
                                </p-menu>
                                <button pButton type="button" (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"
                                    class="p-button-rounded p-button-text"></button>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length + 1" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>



<p-dialog [modal]="true" *ngIf="isAddCourse" [(visible)]="isAddCourse"
    [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">

    <app-create-course (reload)="reloadTable()" [type]="'Create'" [allDepartments]="allDepartments"
        (closeDialog)="handleCloseAdd($event)"></app-create-course>

</p-dialog>


<p-dialog [modal]="true" *ngIf="isEditCourse" [(visible)]="isEditCourse"
    [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">

    <app-create-course (reload)="reloadTable()" [allDepartments]="allDepartments" [type]="'Update'"
        [courseData]="courseData" (closeDialog)="handleCloseEdit($event)"></app-create-course>

</p-dialog>


<p-dialog [modal]="true" *ngIf="isDeleteCourse" [(visible)]="isDeleteCourse"
    [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }" closable="false" [style]="{ width: '30vw' }"
    [draggable]="false" [resizable]="false">

    <app-delete-course [courseData]="courseData" (reload)="reloadTable()"
        (closeDialog)="handleCloseDelete($event)"></app-delete-course>
</p-dialog>